import ComboboxTinh from "./ComboboxTinh";

export default ComboboxTinh